import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  return <Section className="bg-white rounded-3xl my-8 shadow-sm border border-brand-light" data-id="element-13">
      <h2 className="text-3xl md:text-4xl font-serif text-center mb-12 text-brand-text" data-id="element-14">
        ¿Para quién es esto?
      </h2>

      <div className="grid md:grid-cols-2 gap-8 md:gap-16" data-id="element-15">
        {/* For You */}
        <div className="space-y-6" data-id="element-16">
          <div className="flex items-center gap-3 mb-6" data-id="element-17">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-18">
              <Check className="w-6 h-6" data-id="element-19" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-20">Para vos si:</h3>
          </div>

          <ul className="space-y-4" data-id="element-21">
            {['Tenés sofocos que te cortan el día o la noche', 'Te levantás cansada aunque “dormiste”', 'Sentís niebla mental, irritabilidad o “cero paciencia”', 'Ya probaste tips sueltos y querés un sistema simple'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-22">
                <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-23" />
                <span data-id="element-24">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="space-y-6" data-id="element-25">
          <div className="flex items-center gap-3 mb-6" data-id="element-26">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-red-600" data-id="element-27">
              <X className="w-6 h-6" data-id="element-28" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-29">
              No es para vos si:
            </h3>
          </div>

          <ul className="space-y-4" data-id="element-30">
            {['Buscás una cura instantánea o promesas médicas', 'Querés que alguien te diga “tomá X dosis de Y”', 'No estás dispuesta a probar micro-cambios 10 minutos AM y 10 PM'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-31">
                <X className="w-5 h-5 text-red-400 mt-0.5 flex-shrink-0" data-id="element-32" />
                <span data-id="element-33">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}